
const Settings = {
    path: '/settings',
    isSection: true,
    sub: {
        user: {
            path: '/user',
            isSection: true,
            sub: {
                deactivate: '/deactivate',
                timeZoneData: '/time-zone-data',
                metadata: '/metadata',
            }
        },
        statistics: '/statistics', 
        contact: '/contact', 
        metrics: '/metrics', 
        trends: '/trends', 
        domains: '/domains', 
    },
}

export default Settings;